<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton></ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="agregarForm">
      <div class="row">
        <!-- CARD PLANIFICACIÓN -->
        <div class="col-md-6 mb-3">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">
                {{ DAT_TITULOS.titulo }} <span class="text-muted">/ Planificación</span>
              </h5>
              <div style="display: flex; justify-content: center;">
                <table class="table" style="width: auto;">
                  <thead>
                  <tr>
                    <th>Proceso</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td><label for="descarga_partes">Descarga Partes</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="descarga_partes" id="descarga_partes"
                               type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_partes">Envío Partes</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_partes" id="envio_partes" type="checkbox"
                               value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_inventario">Envío Inventario</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_inventario" id="envio_inventario"
                               type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_demandas">Envío Demandas</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_demandas" id="envio_demandas"
                               type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_supply">Envío Supply</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_supply" id="envio_supply" type="checkbox"
                               value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_formulas">Envío Fórmulas (BOM)</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_formulas" id="envio_formulas"
                               type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_consumos">Envío Consumos</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_consumos" id="envio_consumos"
                               type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="processFinish >= processTotal" style="text-align: end;">
                <div class="btn-group-center btn-group mt-3 mb-3">
                  <button (click)="ejecutarProcesos()" class="btn btn-success">
                    <i aria-hidden="true" class="fa fa-play mr-3"></i>
                    &nbsp;{{DAT_BTNS.ejecutar}} Procesos
                  </button>
                </div>
              </div>
              <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
              <div *ngIf="processFinish >= processTotal && processTotal > 0" class="btn-outline-success"
                   style="text-align: end;">
                <i aria-hidden="true" class="fa fa-eject" style="color: green;"></i> Procesos ejecutados
              </div>
              <div *ngIf="processOnDemandError">
                <br><br>
                Error: {{ processOnDemandError }}
              </div>
              <div *ngIf="processDemandAllError">
                <br><br>
                Error: {{ processDemandAllError }}
              </div>
            </div>
          </div>
        </div>

        <!-- CARD PROGRAMACIÓN -->
        <div class="col-md-6 mb-3">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">
                {{ DAT_TITULOS.titulo }} <span class="text-muted">/ Programación</span>
              </h5>
              <div style="display: flex; justify-content: center;">
                <table class="table" style="width: auto;">
                  <thead>
                  <tr>
                    <th>Proceso</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td><label for="envio_workorders">Envío WorkOrders</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_workorders" id="envio_workorders"
                               type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><label for="envio_calendario_mmto">Envío Calendario MMTO</label></td>
                    <td>
                      <div class="checkbox">
                        <input class="checkbox-exec" formControlName="envio_calendario_mmto"
                               id="envio_calendario_mmto" type="checkbox" value=""/>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="programacionFinish >= programacionTotal" style="text-align: end;">
                <div class="btn-group-center btn-group mt-3 mb-3">
                  <button (click)="ejecutarProgramacion()" class="btn btn-success">
                    <i aria-hidden="true" class="fa fa-play mr-3"></i>
                    &nbsp;{{DAT_BTNS.ejecutar}} Procesos
                  </button>
                </div>
              </div>
              <app-lfsa-loading-v2 *ngIf="programacionLoading"></app-lfsa-loading-v2>
              <div *ngIf="programacionFinish >= programacionTotal && programacionTotal > 0"
                   class="btn-outline-success" style="text-align: end;">
                <i aria-hidden="true" class="fa fa-eject" style="color: green;"></i> Procesos ejecutados
              </div>
              <div *ngIf="programacionError">
                <br><br>
                Error: {{ programacionError }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <!-- GRILLA -->
</div>
